import React from 'react';

export default function CoordinateToolHistoryPanel({
  isMobile,
  isFullScreen,
  canViewAllHistory,
  selectedUserId,
  setSelectedUserId,
  fetchHistory,
  users,
  history
}) {
  return (
    <div style={{
      flex: isMobile ? '1 1 auto' : '0 0 220px',
      width: isMobile ? '100%' : 220,
      maxWidth: isMobile ? '100%' : 240,
      overflowY: 'auto',
      maxHeight: isFullScreen ? '80vh' : 500
    }}>
      <h4 style={{ marginBottom: 8 }}>历史记录</h4>
      {!canViewAllHistory && (
        <div style={{ fontSize: 11, color: '#888', marginBottom: 8 }}>仅显示本人记录</div>
      )}

      {canViewAllHistory && (
        <div style={{ marginBottom: 12, padding: 8, background: '#f0f8ff', borderRadius: '4px' }}>
          <div style={{ fontSize: '11px', color: '#666', marginBottom: 4 }}>
            筛选用户记录：
          </div>
          <select
            value={selectedUserId}
            onChange={(e) => {
              setSelectedUserId(e.target.value);
              fetchHistory(e.target.value || null);
            }}
            style={{
              width: '100%',
              padding: '5px 6px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '12px'
            }}
          >
            <option value="">全部用户</option>
            {users.map(user => (
              <option key={user.id} value={user.id}>
                {user.username} ({user.name || user.real_name || '未设置姓名'})
              </option>
            ))}
          </select>
        </div>
      )}

      <div style={{ maxHeight: 400, overflowY: 'auto' }}>
        {history.length === 0 ? (
          <div style={{ color: '#666', textAlign: 'center', padding: 16, fontSize: 12 }}>
            暂无历史记录
          </div>
        ) : (
          history.map((h, i) => (
            <div key={i} style={{ marginBottom: 8, padding: 8, background: '#f9f9f9', borderRadius: '4px' }}>
              <div style={{ fontSize: '11px', color: '#666', wordBreak: 'break-word' }}>
                {new Date(h.timestamp).toLocaleString()} | {h.from_system}→{h.to_system}
                {canViewAllHistory && h.username && (
                  <span style={{ marginLeft: 6, color: '#1976d2', fontWeight: 'bold' }}>
                    | {h.username}
                  </span>
                )}
              </div>
              <div style={{ marginTop: 4, fontSize: '12px', wordBreak: 'break-all' }}>
                <div>原: {JSON.stringify(h.original_coordinates)}</div>
                <div>新: {JSON.stringify(h.converted_coordinates)}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
